// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   CircularProgress,
//   IconButton,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Typography,
// } from "@mui/material";
// import { useSelector } from "react-redux";
// import { decryptToken } from "../../../Utlis/Encryption.js";
// import { BASE_URL } from "../../../components/BaseUrl.js";
// import ArrowDownward from "@mui/icons-material/ArrowDownward";
// import ArrowUpward from "@mui/icons-material/ArrowUpward";
// import MoreVertIcon from "@mui/icons-material/MoreVert";
// import CustomText, { textStyles } from "../../../components/CustomText";
// import empty from "../../../assets/empty.png"; // 👈 adjust path
// import { useTranslation } from "react-i18next";

// // table header & cell styles
// const HeaderStyles = {
//   fontSize: "13px",
//   fontWeight: 600,
//   fontFamily: "Poppins, sans-serif",
//   color: "#003149",
//   backgroundColor: "#f9f9f9",
// };

// const DataStyles = {
//   fontSize: "13px",
//   fontFamily: "Poppins, sans-serif",
//   color: "#333",
// };

// const PlansHistory = () => {
//   const [payments, setPayments] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [sortOrder, setSortOrder] = useState("desc");
// const { t } = useTranslation();

//   const token = useSelector((state) => state.auth.token);
//   const decryptedToken = token ? decryptToken(token) : null;

//   useEffect(() => {
//     const fetchPayments = async () => {
//       try {
//         const response = await fetch(
//           `${BASE_URL}/payments/company-admin/payments?page=1&limit=10`,
//           {
//             method: "GET",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${decryptedToken}`,
//             },
//           }
//         );

//         if (!response.ok) throw new Error("Failed to fetch payments");

//         const result = await response.json();
//         setPayments(result.data?.payments || []);
//       } catch (error) {
//         console.error("Error fetching payment history:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchPayments();
//   }, []);

//   const toggleSort = () => {
//     const sorted = [...payments].sort((a, b) => {
//       const dateA = new Date(a.date);
//       const dateB = new Date(b.date);
//       return sortOrder === "desc" ? dateB - dateA : dateA - dateB;
//     });
//     setPayments(sorted);
//     setSortOrder(sortOrder === "desc" ? "asc" : "desc");
//   };

//   return (
//     <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
//       <Table>
//         {/* Table Head */}
//         <TableHead
//           sx={{
//             borderTop: "2px solid #091E4224",
//             borderBottom: "2px solid #091E4224",
//             whiteSpace: "nowrap",
//           }}
//         >
//           <TableRow>
//             <TableCell sx={{ ...HeaderStyles }}>{t("plans_history.transaction_id")}</TableCell>
//             <TableCell sx={{ ...HeaderStyles }}>{t("plans_history.plan")}</TableCell>
//             <TableCell sx={{ ...HeaderStyles }}>{t("plans_history.amount")}</TableCell>
//             <TableCell sx={{ ...HeaderStyles }}>
//                 {t("plans_history.date")}
//               <IconButton size="small" onClick={toggleSort}>
//                 {sortOrder === "desc" ? (
//                   <ArrowDownward fontSize="small" sx={{ fontSize: "12px" }} />
//                 ) : (
//                   <ArrowUpward fontSize="small" sx={{ fontSize: "12px" }} />
//                 )}
//               </IconButton>
//             </TableCell>
//             <TableCell sx={{ ...HeaderStyles }}>{t("plans_history.status")}</TableCell>
         
//           </TableRow>
//         </TableHead>

//         {/* Table Body */}
//         <TableBody>
//           {loading ? (
//             <TableRow>
//               <TableCell colSpan={6} align="center" sx={{ py: 3 }}>
//                 <CircularProgress size={22} />
//               </TableCell>
//             </TableRow>
//           ) : payments.length === 0 ? (
//             <TableRow>
//               <TableCell colSpan={6}>
//                 <Box
//                   sx={{
//                     flex: 1,
//                     display: "flex",
//                     flexDirection: "column",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     py: 5,
//                   }}
//                 >
//                   <img
//                     src={empty}
//                     alt="No Data"
//                     style={{ width: 200, marginBottom: 16 }}
//                   />
//                   <CustomText
//                     sx={{
//                       ...textStyles.h1,
//                       fontWeight: 500,
//                       fontSize: "16px",
//                       color: "#003149",
//                     }}
//                   >
//                   {t("plans_history.empty")}
//                   </CustomText>
//                 </Box>
//               </TableCell>
//             </TableRow>
//           ) : (
//             payments.map((row, i) => (
//               <TableRow key={i}>
//                 <TableCell sx={{ ...DataStyles }}>{row.txn_id}</TableCell>
//                 <TableCell sx={{ ...DataStyles }}>{row.plan_name}</TableCell>
//                 <TableCell sx={{ ...DataStyles }}>
//                   ${parseFloat(row.amount).toFixed(2)}
//                 </TableCell>
//                 <TableCell sx={{ ...DataStyles }}>
//                   {new Date(row.date).toLocaleDateString("en-US", {
//                     year: "numeric",
//                     month: "long",
//                     day: "numeric",
//                   })}
//                 </TableCell>
//                 <TableCell sx={{ ...DataStyles }}>
//                   {row.status.charAt(0).toUpperCase() + row.status.slice(1)}
//                 </TableCell>
              
//               </TableRow>
//             ))
//           )}
//         </TableBody>
//       </Table>
//     </TableContainer>
//   );
// };

// export default PlansHistory;
import React, { useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Pagination
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../../Redux/Slices/AuthSlice";
import { decryptToken } from "../../../Utlis/Encryption.js";
import { BASE_URL } from "../../../components/BaseUrl.js";
import ArrowDownward from "@mui/icons-material/ArrowDownward";
import ArrowUpward from "@mui/icons-material/ArrowUpward";
import CustomText, { textStyles } from "../../../components/CustomText";
import empty from "../../../assets/empty.png"; 
import { useTranslation } from "react-i18next";

const HeaderStyles = {
  fontSize: "13px",
  fontWeight: 600,
  fontFamily: "Poppins, sans-serif",
  color: "#003149",
  backgroundColor: "#f9f9f9",
};

const DataStyles = {
  fontSize: "13px",
  fontFamily: "Poppins, sans-serif",
  color: "#333",
};

const PlansHistory = () => {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sortOrder, setSortOrder] = useState("desc");
  const [page, setPage] = useState(1);
  const rowsPerPage = 5;
  const { t } = useTranslation();

  const token = useSelector((state) => state.auth.token);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const upgradeToken = new URLSearchParams(window.location.search).get("upgrade_token");
  const decryptedToken = upgradeToken || (token ? decryptToken(token) : null);

  useEffect(() => {
    const fetchPayments = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/payments/company-admin/payments?page=1&limit=50`, // fetch bigger chunk
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${decryptedToken}`,
            },
          }
        );

        if (response.status === 401) {
          // No valid session — send to login instead of showing a broken tab.
          dispatch(logout());
          navigate("/", { replace: true });
          return;
        }

        if (!response.ok) throw new Error("Failed to fetch payments");

        const result = await response.json();
        setPayments(result.data?.payments || []);
      } catch (error) {
        console.error("Error fetching payment history:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPayments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [decryptedToken]);

  const toggleSort = () => {
    const sorted = [...payments].sort((a, b) => {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);
      return sortOrder === "desc" ? dateB - dateA : dateA - dateB;
    });
    setPayments(sorted);
    setSortOrder(sortOrder === "desc" ? "asc" : "desc");
  };

  // Slice payments for current page
  const startIndex = (page - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const currentRows = payments.slice(startIndex, endIndex);
  const totalPages = Math.ceil(payments.length / rowsPerPage);

  return (
    <>
      <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
        <Table>
          <TableHead
            sx={{
              borderTop: "2px solid #091E4224",
              borderBottom: "2px solid #091E4224",
              whiteSpace: "nowrap",
            }}
          >
            <TableRow>
              <TableCell sx={{ ...HeaderStyles }}>{t("plans_history.transaction_id")}</TableCell>
              <TableCell sx={{ ...HeaderStyles }}>{t("plans_history.plan")}</TableCell>
              <TableCell sx={{ ...HeaderStyles }}>{t("plans_history.amount")}</TableCell>
              <TableCell sx={{ ...HeaderStyles }}>
                {t("plans_history.date")}
                <IconButton size="small" onClick={toggleSort}>
                  {sortOrder === "desc" ? (
                    <ArrowDownward fontSize="small" sx={{ fontSize: "12px" }} />
                  ) : (
                    <ArrowUpward fontSize="small" sx={{ fontSize: "12px" }} />
                  )}
                </IconButton>
              </TableCell>
              <TableCell sx={{ ...HeaderStyles }}>{t("plans_history.status")}</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={6} align="center" sx={{ py: 3 }}>
                  <CircularProgress size={22} />
                </TableCell>
              </TableRow>
            ) : payments.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6}>
                  <Box
                    sx={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      py: 5,
                    }}
                  >
                    <img
                      src={empty}
                      alt="No Data"
                      style={{ width: 200, marginBottom: 16 }}
                    />
                    <CustomText
                      sx={{
                        ...textStyles.h1,
                        fontWeight: 500,
                        fontSize: "16px",
                        color: "#003149",
                      }}
                    >
                      {t("plans_history.empty")}
                    </CustomText>
                  </Box>
                </TableCell>
              </TableRow>
            ) : (
              currentRows.map((row, i) => (
                <TableRow key={i}>
                  <TableCell sx={{ ...DataStyles }}>{row.txn_id}</TableCell>
                  <TableCell sx={{ ...DataStyles }}>{row.plan_name}</TableCell>
                  <TableCell sx={{ ...DataStyles }}>
                    ${parseFloat(row.amount).toFixed(2)}
                  </TableCell>
                  <TableCell sx={{ ...DataStyles }}>
                    {new Date(row.date).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })}
                  </TableCell>
                  <TableCell sx={{ ...DataStyles }}>
                    {row.status.charAt(0).toUpperCase() + row.status.slice(1)}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination control */}
      {payments.length > rowsPerPage && (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          <Pagination
            count={totalPages}
            page={page}
            shape="rounded"
          color="primary"
            onChange={(e, value) => setPage(value)}
          />
        </Box>
      )}
    </>
  );
};

export default PlansHistory;
